import AdminAgentDock from "../../admin-agent/components/AdminAgentDock";
import { themeAtom } from "../../shared/atoms";
import { logV } from "../../shared/services/debug-logger";
import AdminSidebar from "../components/admin-page/AdminSidebar";
import { adminStyles } from "../styles/admin.styles";
import { useAtomValue } from "jotai";
import { Outlet } from "react-router-dom";
import { twMerge } from "tailwind-merge";

// Admin shell owns the sidebar and route outlet while keeping the standard app header.
const AdminPage = () => {
  const theme = useAtomValue(themeAtom);
  logV("AdminPage - BUILD");

  return (
    <div
      data-test="admin-shell"
      className={twMerge(adminStyles.page.shell, theme.home.tailwind.pageBackground, theme.home.tailwind.textDefault)}
    >
      <AdminSidebar />

      <div data-test="admin-content" className={adminStyles.page.content}>
        <Outlet />
      </div>
      <AdminAgentDock />
    </div>
  );
};

export default AdminPage;
